import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../services/api";

const referenceTypes = ["PURCHASE_INVOICE", "DELIVERY", "RETURN", "SCHEME_REWARD", "ADJUSTMENT"];

const StockLedger = () => {
  const [entries, setEntries] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productFilter, setProductFilter] = useState("");
  const [referenceTypeFilter, setReferenceTypeFilter] = useState("");

  const loadProducts = async () => {
    try {
      const data = await api.get("/api/v1/products", { size: 200 });
      setProducts(data?.content || []);
    } catch (error) {
      toast.error(error.message || "Failed to load products");
    }
  };

  const loadLedger = async () => {
    setLoading(true);
    try {
      const data = await api.get("/api/v1/inventory/ledger", {
        size: 200,
        productId: productFilter || undefined,
        referenceType: referenceTypeFilter || undefined,
      });
      setEntries(data?.content || []);
    } catch (error) {
      toast.error(error.message || "Failed to load stock ledger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);

  useEffect(() => {
    loadLedger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productFilter, referenceTypeFilter]);

  return (
    <div className="p-4" style={{ position: "relative" }}>
      {loading ? (
        <div className="loading-overlay">
          <div className="spinner-card">
            <div className="spinner-ring" />
            <div className="spinner-label">Loading stock ledger...</div>
          </div>
        </div>
      ) : null}

      <div className="filters-bar">
        <select value={productFilter} onChange={(e) => setProductFilter(e.target.value)}>
          <option value="">All products</option>
          {products.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name} ({p.skuCode})
            </option>
          ))}
        </select>
        <select value={referenceTypeFilter} onChange={(e) => setReferenceTypeFilter(e.target.value)}>
          <option value="">All reference types</option>
          {referenceTypes.map((rt) => (
            <option key={rt} value={rt}>
              {rt}
            </option>
          ))}
        </select>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Product</th>
              <th>Warehouse</th>
              <th>Batch #</th>
              <th>Qty Change</th>
              <th>Balance After</th>
              <th>Reference</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 ? (
              <tr>
                <td colSpan={8}>No ledger entries found.</td>
              </tr>
            ) : (
              entries.map((entry) => (
                <tr key={entry.id}>
                  <td>{entry.createdAt ? new Date(entry.createdAt).toLocaleString() : "-"}</td>
                  <td>{entry.productName}</td>
                  <td>{entry.warehouseName}</td>
                  <td>{entry.batchNumber || "-"}</td>
                  <td style={{ color: Number(entry.quantityChange) < 0 ? "#c62828" : "#1e8e3e" }}>
                    {Number(entry.quantityChange) > 0 ? "+" : ""}
                    {entry.quantityChange}
                  </td>
                  <td>{entry.balanceAfter}</td>
                  <td>
                    <span className="badge badge-blue">{entry.referenceType}</span>
                    {entry.referenceId ? ` #${entry.referenceId}` : ""}
                  </td>
                  <td>{entry.reason || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StockLedger;
